import { Button, Stack, TextInput } from "@mantine/core";
import { createAIKey } from "../../../../api/ConfigsApi";
import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";

const OvhNoKey = ({ onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    createAIKey({
      name: data.name,
      api_key: data.api_key,
      type: "ovh",
      api_secret: data.api_secret,
      consumer_key: data.consumer_key,
    })
      .then((res) => {
        onFinish(res.data.id);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack component={"form"} gap={"xs"} onSubmit={handleSubmit}>
      <TextInput
        name="name"
        label={lang.ovh.no_key.name_label}
        placeholder={lang.ovh.no_key.name_placeholder}
        size="md"
        required
      />
      <TextInput
        name="api_key"
        label={lang.ovh.no_key.api_key}
        placeholder={lang.ovh.no_key.api_key_placeholder}
        size="md"
        required
      />
      <TextInput
        name="api_secret"
        label={lang.ovh.no_key.secret_label}
        placeholder={lang.ovh.no_key.secret_placeholder}
        size="md"
        required
      />
      <TextInput
        name="consumer_key"
        label={lang.ovh.no_key.consumer_label}
        placeholder={lang.ovh.no_key.consumer_placeholder}
        size="md"
        required
      />
      <Button type="submit" loading={loading} size="md" mt={16}>
        {lang.ovh.no_key.add_key}
      </Button>
    </Stack>
  );
};

export default OvhNoKey;
